import { H3, InsetText, ListItem, UnorderedList } from "govuk-react";
import React, { memo, useCallback } from "react";
import { useForm } from "../hooks/formContext";
import { GovField } from "@publicMirage/components/govReact/GovField";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import DragAndDropFiles from "@mirage/components/dragAndDrop/DragAndDropFiles";
import { FileContent } from "@shared/mirage/core/contracts/UploadedFile";

export const PrePpWlEssentialSection = memo(() => {
    const { toFieldProps, setFieldValue, setFormState, formState } = useForm();
    const { siteLocationDocuments } = formState;
    const uploadOnChange = useCallback(
        async (_: FileContent[], originalFiles: File[] | null) => {
            const docs = originalFiles?.map((file) => {
                return new File([file], file.name, { type: file.type });
            });
            setFieldValue("siteLocationDocuments", docs);
        },
        [setFieldValue]
    );
    const removeAttachment = (index: number) => {
        setFormState((prev) => {
            return {
                ...prev,
                siteLocationDocuments: {
                    errorMsg: prev.siteLocationDocuments.errorMsg,
                    value: prev.siteLocationDocuments.value?.filter((_, i) => i !== index),
                },
            };
        });
    };
    return (
        <>
            <H3>Essential</H3>
            <InsetText>
                The following is required in addition to completing this form. Please note, your application cannot move forward without these.
                <UnorderedList>
                    <ListItem>Correct fee for pre application advice.</ListItem>
                    <ListItem>
                        Site Location Plan with the site clearly outlined with a red line. If the site owner also owns any adjoining land, please outline this in blue - a scale of
                        1:1250 or 1:2500 is preferred.
                    </ListItem>
                </UnorderedList>
            </InsetText>
            <DragAndDropFiles onDrop={uploadOnChange} onClick={uploadOnChange} label="Drop file or click to upload site location documents." />
            <Box sx={{ display: "flex", "flex-wrap": "wrap", gap: "0.5rem", margin: "1rem 0" }}>
                {siteLocationDocuments.value?.map((attachment, index) => {
                    return (
                        <Chip
                            label={attachment.name}
                            onDelete={() => removeAttachment(index)}
                            key={`${attachment.name}-${index}`}
                            sx={{ backgroundColor: "rgba(3, 87, 166, 0.2)" }}
                        />
                    );
                })}
            </Box>
            <GovField {...toFieldProps("hardCopySiteLocationPlansWillBeProvided", "CHECKBOX")} />
        </>
    );
});
